import React from 'react'
import url from 'front-end-core/core/url'
import Facet from 'components/search/Facet'
import { FiltersHeader } from 'components/search/Facets'
import { SEARCH } from 'constants/controllers'
import { updateHistoryState } from 'front-end-core/core/history'
import { useDispatch, useSelector } from 'react-redux'
import { isArray, xor } from 'libraries/lodash'
import selectController from 'redux/selectors/selectController'
import selectSearchQuery from 'redux/selectors/selectSearchQuery'
import { setSearchState } from 'redux/actions'

const SearchFilters = ({
  flavour,
  searchType,
  paginationMode,
  searchPhrase,
  facets,
  aol
}) => {
  const _query = useSelector(selectSearchQuery)
  const controller = useSelector(selectController)

  const dispatch = useDispatch()

  const handleFacetOptionClick = (parameterName, value, selected) => {
    if (setSearchState) {
      const query = Object.assign({ [parameterName]: [] }, _query)

      query[parameterName] = xor(
        (isArray(query[parameterName]) && query[parameterName]) || [query[parameterName]],
        [value]
      )

      if (!selected) {
        delete query[parameterName][value]
      }

      const pageNumber = paginationMode === 'all' && 'all'

      dispatch(setSearchState({ pageNumber, query }))

      const urlNode = url(SEARCH, { aol, flavour, searchPhrase, searchType, pageNumber }, query)
      history.pushState({}, null, urlNode) // Global browser level var
      updateHistoryState({ viewName: controller })
    }
  }
  return (
    <div className='mt6 mb4 pa5 bg-white'>
      <FiltersHeader {...{ flavour, searchType, searchPhrase, aol }} />
      {facets.map((facet, index) => facet.options.length === 0
        ? null
        : (
          <Facet key={index} {...{ ...facet, searchType, handleFacetOptionClick }} />
          ))}
    </div>
  )
}

export default SearchFilters
